import { AuthReducerModal } from "./initialState";
import services from '../../Constant/service';
import endpoint from '../../Constant/endpoint';
import { createSlice, createAsyncThunk, isPending, isFulfilled, isRejected } from '@reduxjs/toolkit';
const initialState = new AuthReducerModal();


// Async Thunk for getTutorDetails

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    set: (state, action) => ({ ...state, ...action.payload }),
    loader: (state, action) => ({ ...state, isLoader: action.payload }),
    reset: () => { },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => ({ ...state, isLoader: true }))
      .addMatcher(isFulfilled, (state, action) => {
        const actionName = action.type.split('/')[1];
        const dynamicKey = `${actionName}Response`;

        return {
          ...state,
          isLoader: false,
          [dynamicKey]: action.payload
        };
      })
      .addMatcher(isRejected, (state) => ({ ...state, isLoader: false }));
  },
});


export const login = createAsyncThunk(
  "auth/login",
  async (
    {
      params,
      callback,
      errorCallback,
    }: { params: any; callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      await services.postApiCall(
        endpoint.auth.login,
        params,
        (res: any) => {
          if (res?.statusCode === services?.status_code?.success) {
            const accessToken = res.data.token.access.token;
            const refreshToken = res.data.token.refresh.token;
            // Store tokens in localStorage
            localStorage.setItem("ACCESS_TOKEN", accessToken);
            localStorage.setItem("REFRESH_TOKEN", refreshToken);
            // Update Redux state
            dispatch(set({ ACCESS_TOKEN: accessToken }));
            // Set token in Axios headers
            services.setAuthorizationToken(accessToken);
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg || "Login failed");
          }
        },
        () => { }
      );
    } catch (error: any) {
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async ({ callback, errorCallback }: { callback: (data: any) => void, errorCallback: (error?: any) => void }, { dispatch, rejectWithValue }) => {
    try {
      await services.postApiCall(
        endpoint.auth.logout,
        {},
        (res: any) => {
          if (res?.statusCode === services?.status_code?.success) {
            services.setAuthorizationToken("");
            callback(res);
            return res;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg || "Login failed");
          }
        },
        () => { },
      );
    } catch (error: any) {
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
export const getState = createAsyncThunk(
  "general/getState",
  async (
    {
      callback,
      errorCallback,
    }: { callback: (data: any) => void; errorCallback: (error?: any) => void },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(set({ isLoader: true }));
      await services.getApiCall(
        endpoint.general.getState,
        "",
        (res: any) => {
          if (res?.data?.statusCode === services?.status_code?.success) {
            callback(res.data);
            return res.data;
          } else {
            errorCallback(res);
            return rejectWithValue(res?.msg);
          }
        },
        () => { }
      );
    } catch (error: any) {
      dispatch(set({ isLoader: false }));
      errorCallback(error);
      return rejectWithValue(error.message);
    }
  }
);
// const homeSlice = createSlice({
//   name: "home",
//   initialState,
//   reducers: {
//     set: (state, action) => {
//       return { ...state, ...action.payload };
//     },
//     loader: (state, action) => {
//       state.isLoader = action.payload; // Directly modify state (immer handles immutability under the hood)
//     },
//     reset: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(login.pending, (state) => {
//         state.isLoader = true;
//         // state.error = null;
//       })
//       .addCase(login.fulfilled, (state, action) => {
//         state.isLoader = false;
//         // state.tutorDetails = action.payload;
//       })
//       .addCase(login.rejected, (state, action) => {
//         state.isLoader = false;
//         // state.error = action.payload;
//       });
//   },
// });


export const { set, loader, reset } = homeSlice.actions; // Export the actions
export default homeSlice.reducer; // Export the reducer
